// extracted by mini-css-extract-plugin
export default {"custom_table_container":"index_custom_table_container__R+kIv","empty_state_text":"index_empty_state_text__GipKg","no_data":"index_no_data__7S+0q"};